import WinColorFull from '../../controls/finish/WinColorFull';
import ColorFinishing from '../../controls/finish/ColorFinishing';
import GrillColor from '../../controls/grill/GrillColor';

export const getFinishSection = (props) => {
  const {
    SECTIONS,
    isDisabled,
    interiorColorValue, setInteriorColorValue,
    exteriorColorValue, setExteriorColorValue,
    colorFinishingValue, setColorFinishingValue,
    grillsInteriorColorValue, setGrillsInteriorColorValue,
    grillsExteriorColorValue, setGrillsExteriorColorValue,
    archGrillTypeValue1,
    grillTypeTopValue1,
    grillTypeTopValue2,
    grillTypeTopValue3,
    grillTypeTopValue4,
    grillTypeTopValue5,
    grillTypeValue1,
    grillTypeValue2,
    grillTypeValue3,
    grillTypeValue4,
    grillTypeValue5,
  } = props;

  return [
    // Finish section starts ...
    { id: "WinColorFull2", component: <WinColorFull controlId={2}
      disabled={isDisabled}
      value={interiorColorValue} // ✅ Pass current state value
      onChange={(newValue) =>
      { setInteriorColorValue(newValue); }
      } label='Color Interior' color={interiorColorValue} colorType="internal" />,
      position: [1, 1], status: "active", expandableSectionId: "Finish" },

    { id: "WinColorFull1", component: <WinColorFull controlId={1}
      disabled={isDisabled}
      value={exteriorColorValue} // ✅ Pass current state value
      onChange={(newValue) =>
      { setExteriorColorValue(newValue); }
      } label='Color Exterior' color={exteriorColorValue} colorType="external" />,
      position: [1, 2], status: "active", expandableSectionId: "Finish" },


    { id: "ColorFinishing",  component: 1 > SECTIONS ? null : ( <ColorFinishing
      disabled={isDisabled} id = {"ColorFinishing"} label={"Color Finishing"}
      value={colorFinishingValue}  onChange={(newValue) => { setColorFinishingValue(newValue);}
    }/>),   position: [2, 1], status: "active", expandableSectionId: "Finish" },

    ((archGrillTypeValue1 !== "None") ||
    (grillTypeTopValue1 !== "None") ||
    (grillTypeTopValue2 !== "None") ||
    (grillTypeTopValue3 !== "None") ||
    (grillTypeTopValue4 !== "None") ||
    (grillTypeTopValue5 !== "None") ||
    (grillTypeValue1 !== "None") ||
    (grillTypeValue2 !== "None") ||
    (grillTypeValue3 !== "None") ||
    (grillTypeValue4 !== "None") ||
    (grillTypeValue5 !== "None")) &&
    { id: "GrillColorInterior", component: <GrillColor controlId={1}
    disabled={isDisabled}
    value={grillsInteriorColorValue}
    onChange={(newValue) =>
    { setGrillsInteriorColorValue(newValue); }
    } label='Grills Color Interior' colorType='interior'/>,
    position: [3, 1], status: "active", expandableSectionId: "Finish" },

   ((archGrillTypeValue1 !== "None") ||
    (grillTypeTopValue1 !== "None") ||
    (grillTypeTopValue2 !== "None") ||
    (grillTypeTopValue3 !== "None") ||
    (grillTypeTopValue4 !== "None") ||
    (grillTypeTopValue5 !== "None") ||
    (grillTypeValue1 !== "None") ||
    (grillTypeValue2 !== "None") ||
    (grillTypeValue3 !== "None") ||
    (grillTypeValue4 !== "None") ||
    (grillTypeValue5 !== "None")) &&
    { id: "GrillColorExterior", component: <GrillColor controlId={2}
    disabled={isDisabled}
    value={grillsExteriorColorValue}
    onChange={(newValue) =>
    { setGrillsExteriorColorValue(newValue); }
    } label='Grills Color Exterior' colorType='exterior'/>,
    position: [3, 2], status: "active", expandableSectionId: "Finish" },

    // Finish ends ...
  ];
};
